import { WebPlugin } from '@capacitor/core';
export class ScrollbarHiderWeb extends WebPlugin {
    async hideScrollbars() {
        // On web, scrollbars are already hidden via CSS
        // This is just a no-op for web compatibility
        console.log('ScrollbarHider: Web scrollbars handled via CSS');
    }
}
//# sourceMappingURL=web.js.map